import { render } from "./component.vue?vue&type=template&id=bc986f16&scoped=true"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"

import "./component.vue?vue&type=style&index=0&id=bc986f16&lang=scss&scoped=true"

import exportComponent from "/opt/data/jenkins/workspace/auto-build-release-node-server-new-2024/TMP/PROD/ashe/ashe-activity/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc986f16"]])

export default __exports__